import { render } from "./RegistrationCard.vue?vue&type=template&id=3ba6770a&scoped=true"
import script from "./RegistrationCard.vue?vue&type=script&lang=js"
export * from "./RegistrationCard.vue?vue&type=script&lang=js"

import "./RegistrationCard.vue?vue&type=style&index=0&id=3ba6770a&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba6770a"]])

export default __exports__